<template>
  <div class="get-rewards" :class="{'get-rewards_full-width': fullWidth}">
    <div class="get-rewards__info-container" :class="{'get-rewards__info-container_full-width': fullWidth}">
      <div class="get-rewards__info" :class="{'get-rewards__info_full-width': fullWidth}">
        <div 
          class="info__image" 
          :class="{'info__image_full-width': fullWidth}"
          :style="`background-image: url('${image}');`"
        ></div>
        <div class="info__text" :class="{'info__text_full-width': fullWidth}">
          <div class="info__title" v-html="title"></div>
          <div class="info__subtitle" v-html="subtitle"></div>
          <div class="info__note" v-html="note"></div>
        </div>
      </div>
    </div>
    <div class="get-rewards__rewards-container" :class="{'get-rewards__rewards-container_full-width': fullWidth}">
      <div class="get-rewards__rewards" :class="{'get-rewards__rewards_full-width': fullWidth}">
        <Slider 
          :cols="cols"
          :noPagination="noPagination"
          class="rewards__slider"
          :class="{'rewards__slider_full-width': fullWidth}"
        >
          <slot></slot>
        </Slider>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@sc-component-library/slider/src/main';

export default {
  name: 'GetRewards',
  designVersion: '1.0.0',
  components: {
    Slider,
  },
  props: {
    /**
     * Изображение
     */
    image: {
      type: String,
    },
    /**
     * Текст заголовка
     */
    title: {
      type: String,
    },
    /**
     * Текст подзаголовка
     */
    subtitle: {
      type: String,
    },
    /**
     * Текст заметки
     */
    note: {
      type: String,
    },
    /**
     * Область контента на всю ширину или 1024px
     */
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cols() {
      if (this.fullWidth) return { default: '1', md: '2', lg: '3', xl: '4' };
      return { default: '1', md: '2', lg: '3', xl: '3' };
    },
    noPagination() {
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./GetRewards";
</style>
